module.exports = {
    RECEIVE_LAST_MESSAGES: 'RECEIVE_LAST_MESSAGES',
    RECEIVE_MESSAGES_USER: 'RECEIVE_MESSAGES_USER',
}